module.exports = "<div id=\"{{divId}}\" [style.width.%]=\"100\" [style.height.px]=\"500\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/day-trading-chart/day-trading-chart.component.html
// module id = ../../../../../src/app/components/day-trading-chart/day-trading-chart.component.html
// module chunks = main